import { useEffect, useState } from 'react'
import { withTranslation } from "react-i18next"
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { SeoTags } from '../../components'
import { FlightsDirectionInfoComponent } from '../../components/info/FlightDirectionsComponent'
import { setSearchBlockCompact, setShowSearch } from '../../store/appConfigsSlice'

function FlightsDirectionInfoPage () {
  const dispatch = useDispatch()
  const { route } = useParams();

  const [from, to] = route.split('-');

  const [flightData, setFlightData] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const getFlightData = async () => {
      const flightData = await import(`../../info/flightsInfoJsons/${route}.json`);

      if(!!flightData?.default) {
        setFlightData((flightData?.default))
      } else {
        navigate('/')
      }
    }

    if (route) {
      getFlightData()
    }
  }, [route, navigate])

	useEffect(() => {
    dispatch(setShowSearch(true));
    dispatch(setSearchBlockCompact(true));
  }, [dispatch]);

    return (
      <>
        <SeoTags pageKey={flightData?.pageKey} />
        <FlightsDirectionInfoComponent from={from} to={to} />
      </>
    )
  
};

export default withTranslation()(FlightsDirectionInfoPage);